module.exports = __webpack_public_path__ + "facelifting_6_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/facelifting_6_after.jpg
// module id = 1059
// module chunks = 0